import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const signIn: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M9.11-5.36q.14.16.14.36 0 .204-.14.344L4.86-.406a.5.5 0 0 1-.36.156.52.52 0 0 1-.36-.14A.52.52 0 0 1 4-.75V-3H.5a.52.52 0 0 1-.36-.14A.52.52 0 0 1 0-3.5v-3q0-.201.14-.344A.5.5 0 0 1 .5-7H4v-2.25q0-.201.14-.344a.5.5 0 0 1 .36-.156q.2 0 .36.14zM12-7.75v5.5q0 .925-.656 1.594A2.17 2.17 0 0 1 9.75 0h-2.5a.23.23 0 0 1-.172-.078A.23.23 0 0 1 7-.25q-.002-.028-.016-.156V-.61q.013-.094.032-.188c.007-.07.035-.125.078-.156A.25.25 0 0 1 7.25-1h2.5c.344 0 .633-.117.875-.36Q11-1.733 11-2.25v-5.5a1.17 1.17 0 0 0-.375-.875A1.17 1.17 0 0 0 9.75-9H7.219a.3.3 0 0 1-.094-.031l-.062-.047a.14.14 0 0 1-.047-.063A.3.3 0 0 1 7-9.25q-.002-.028-.016-.156v-.203q.013-.094.032-.188c.007-.07.035-.125.078-.156A.25.25 0 0 1 7.25-10h2.5a2.17 2.17 0 0 1 1.594.656Q12-8.687 12-7.75m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10)"
    />
  ),
  svgProps: {
    height: "10.5",
    width: "12",
  }
};
